import React from 'react'
import {
  Container,
  Row,
  Col,
  Table
} from 'reactstrap'
import { ListItem } from '.'
import { IgtLoader } from 'Atoms'

const VirtualMachinesList = ({ modelList, isLoading }) => {
  return (
    <Container fluid>
      <Row>
        <Col lg={{ size: 6, offset: 3}}>
          <h1 className="text-center">Virtual Machines Table</h1>
        </Col>
      </Row>
      <Row>
        <Col lg="12">
          {
            isLoading ?
            <IgtLoader isLoading={isLoading}/>
            :
            <Table hover>
              <thead className='sticky-header'>
                <tr>
                  <th>Resource ID</th>
                  <th>State</th>
                  <th>Cloud</th>
                  <th>Identifier</th>
                  <th>Name</th>
                  <th>Location</th>
                  <th>Resource type</th>
                  <th>Business Unit</th>
                  <th>Cost Center</th>
                </tr>
              </thead>
              <tbody>
                {
                  modelList && modelList.map((parent, i) => {
                    return (
                      <ListItem
                        modelListItem={parent}
                        key={i}
                        index={i}
                      />
                    )
                  })
                }
              </tbody>
            </Table>
          }
        </Col>
      </Row>
    </Container>
  )
}

export default VirtualMachinesList